import FallbackImage from '~/assets/images/product-placeholder_2-1.svg'

/**
 * @description Image loader composable.
 * It provides a way to handle image loading and error events on <img> elements.
 */
export function useImageLoader() {
  const hasImageLoaded = ref(false)

  /**
   * @description Image loaded handler added to @load event of <img> element.
   */
  function onImageLoad() {
    hasImageLoaded.value = true
  }

  /**
   * @description Fallback image handler added to @error event of <img> element.
   * @param event
   */
  function onImageError(event: any) {
    event.target.src = FallbackImage
  }

  return {
    hasImageLoaded: readonly(hasImageLoaded),
    onImageLoad,
    onImageError
  }
}
